import segments from "./segments";
import requestBase from "./requestBase";
import requestBaseFile from "./requestBaseFile";

// 省市县三级联动
export const areasList = (paramters) => requestBase.post(`${segments.urlSegmentCommon}/api/bAreasList`, paramters);

// 围栏
export const fenceList = (paramters) => requestBase.post(`${segments.urlSegmentVGS}/fence/tmsList`, paramters);
export const fenceUpdate = (paramters) => requestBase.post(`${segments.urlSegmentVGS}/fence/update`, paramters);
export const fenceCreate = (paramters) => requestBase.post(`${segments.urlSegmentVGS}/fence/add`, paramters);
export const fenceDelete = (paramters) => requestBase.post(`${segments.urlSegmentVGS}/fence/delete`, paramters);

/** 星瀚 **/
// 打包
export const packageList = (paramters) => requestBase.post(`${segments.urlSegmentStock}/packag/getPackagRecordList`, paramters);

/** 中厚板 **/
// 非道路机械台账页面接口
export const noroadinfoList = (paramters) => requestBase.post(segments.urlDriverName + "/vehicle/noroadinfo/list", paramters);
export const noroadinfoListExport = (paramters) => requestBaseFile.post(segments.urlDriverName + "/vehicle/noroadinfo/exportList", paramters);
export const noroadinfoAdd = (paramters) => requestBase.post(segments.urlDriverName + "/vehicle/noroadinfo/add", paramters);
export const noroadinfoUpdate = (paramters) => requestBase.post(segments.urlDriverName + "/vehicle/noroadinfo/update", paramters);
export const noroadinfoDelete = (paramters) => requestBase.post(segments.urlDriverName + "/vehicle/noroadinfo/delete", paramters);

// 车辆管理
export const cVIlist = (paramters) => requestBase.post(segments.urlDriverName + "/cVehicleInfo/list", paramters);

// 台账预警
export const warningList = (paramters) => requestBase.post(segments.urlDriverName + "/warning/list", paramters);
export const warningListExport = (paramters) => requestBaseFile.post(segments.urlDriverName + "/warning/exportlist", paramters);
export const warningDelete = (paramters) => requestBase.post(segments.urlDriverName + "/warning/delete", paramters);
export const warningUpdate = (paramters) => requestBase.post(segments.urlDriverName + "/warning/update", paramters);

// 进仓登记
export const getQueueSettingsList = (paramters) => requestBase.post(segments.urlLeju + "/factory/getQueueSettingsList", paramters);
export const getJobStatusList = (paramters) => requestBase.post(segments.urlLeju + "/factory/getJobStatusList", paramters);
export const getSchedulingAssignmentList = (paramters) => requestBase.post(segments.urlLeju + "/factory/getSchedulingAssignmentList", paramters);

export const searchPhoneNumber = (paramters) => requestBase.post(segments.urlLeju + "/driver/listByAccount", paramters);
export const register = (paramters) => requestBase.post(segments.urlLeju + "/scheduling/vehicleRegisterPC", paramters);

export const driverVehicleInList = (paramters) => requestBase.post(segments.urlSegmentStock + "/driverVehicleInformation/getDriverVehicleInList", paramters);
export const markDriverVehicle = (paramters) => requestBase.post(segments.urlSegmentStock + "/driverVehicleInformation/markDriverVehicleIn", paramters);
export const deleteDriverVehicle = (paramters) => requestBase.post(segments.urlSegmentStock + "/driverVehicleInformation/deleteDriverVehicleIn", paramters);
export const detailByIDDriverVehicle = (paramters) => requestBase.post(segments.urlSegmentStock + "/driverVehicleInformation/detail", paramters);
export const detailByPlateNumberDriverVehicle = (paramters) => requestBase.post(segments.urlSegmentStock + "/driverVehicleInformation/getDriverVehicleInfo", paramters);

export const yearWaterTransList = (paramters) => requestBase.post(segments.urlDataCenter + "/dShipDate/weightByMonth", paramters);
export const recordList = (paramters) => requestBase.post(segments.urlDataCenter + "/dShipDate/shipDateList", paramters);
export const listTotal = (paramters) => requestBase.post(segments.urlDataCenter + "/dShipDate/sumHistoryWeight", paramters);
export const waterStatusList = (paramters) => requestBase.post(segments.urlDataCenter + "/dShipDate/statusCount", paramters);
export const listTrans = (paramters) => requestBase.post(segments.urlDataCenter + "/freighter/listTrans", paramters);
export const addressList = (paramters) => requestBase.post(segments.urlDataCenter + "/freighter/addressList", paramters);
export const codeDataList = (paramters) => requestBase.post(segments.urlDataCenter + "/dShipDate/shipAddressAndCoordinate", paramters);

// Branch
export const branchList = (params) =>
    requestBase.request({
        method: "get",
        url: segments.urlAss + "/branches",
        params: params,
    });
export const branchAdd = (data) =>
    requestBase.request({
        method: "post",
        url: segments.urlAss + "/branches",
        data: data,
    });
export const branchEdit = (data) =>
    requestBase.request({
        method: "put",
        url: segments.urlAss + "/branches/" + data.id,
        data: data,
    });
export const branchDelete = (data) =>
    requestBase.request({
        method: "delete",
        url: segments.urlAss + "/branches/" + data.id,
    });

// Role
export const roleList = (params) =>
    requestBase.request({
        method: "get",
        url: segments.urlAss + "/roles",
        params: params,
    });
export const roleAdd = (data) =>
    requestBase.request({
        method: "post",
        url: segments.urlAss + "/roles",
        data: data,
    });
export const roleEdit = (data) =>
    requestBase.request({
        method: "put",
        url: segments.urlAss + "/roles/" + data.id,
        data: data,
    });
export const roleDelete = (data) =>
    requestBase.request({
        method: "delete",
        url: segments.urlAss + "/roles/" + data.id,
    });
export const roleBatchDelete = (data) =>
    requestBase.request({
        method: "post",
        url: segments.urlAss + "/roles/batchDelete",
        data: data,
    });
export const profileUpdatePassword = (paramters) => requestBase.put(segments.urlAss + "/profile/updatePassword", paramters);

// Item
export const itemList = (params) =>
    requestBase.request({
        method: "get",
        url: segments.urlAss + "/items",
        params: params,
    });
export const itemAdd = (data) =>
    requestBase.request({
        method: "post",
        url: segments.urlAss + "/items",
        data: data,
    });
export const itemEdit = (data) =>
    requestBase.request({
        method: "put",
        url: segments.urlAss + "/items/" + data.id,
        data: data,
    });

export const itemDelete = (data) =>
    requestBase.request({
        method: "delete",
        url: segments.urlAss + "/items/" + data.id,
    });
export const itemGenerate = () =>
    requestBase.request({
        method: "get",
        url: segments.urlAss + "/items/generate",
    });

// Placeholder
export const placeholder = (params) =>
    requestBase.request({
        method: "get",
        url: segments.urlAss + "/placeholder",
        params: params,
    });

export const ttsGenerate = () =>
    requestBase.request({
        method: "get",
        url: segments.urlAss + "/tts/generate",
    });

// Service
export const serviceList = (params) =>
    requestBase.request({
        method: "get",
        url: segments.urlAss + "/services",
        params: params,
    });
export const serviceAdd = (data) =>
    requestBase.request({
        method: "post",
        url: segments.urlAss + "/services",
        data: data,
    });
export const serviceEdit = (data) =>
    requestBase.request({
        method: "put",
        url: segments.urlAss + "/services/" + data.id,
        data: data,
    });
export const serviceDelete = (data) =>
    requestBase.request({
        method: "delete",
        url: segments.urlAss + "/services/" + data.id,
    });

// Worker
export const workerList = (params) =>
    requestBase.request({
        method: "get",
        url: segments.urlAss + "/workers",
        params: params,
    });
    export const workergrant = (params) =>
        requestBase.request({
            method: "get",
            url: segments.urlAss + "/workers/grant",
            params: params,
        });
export const workerAdd = (data) =>
    requestBase.request({
        method: "post",
        url: segments.urlAss + "/workers",
        data: data,
    });
export const workerEdit = (data) =>
    requestBase.request({
        method: "put",
        url: segments.urlAss + "/workers/" + data.id,
        data: data,
    });
export const workerDelete = (data) =>
    requestBase.request({
        method: "delete",
        url: segments.urlAss + "/workers/" + data.id,
    });

// Orders
export const orderList = (params) =>
    requestBase.request({
        method: "get",
        url: segments.urlAss + "/orders",
        params: params,
    });
export const orderAssign = (data) =>
    requestBase.request({
        method: "put",
        url: segments.urlAss + "/orders/" + data.id,
        data: data,
    });
// Get Info
export const getUserInfo = (params) =>
    requestBase.request({
        method: "get",
        url: segments.urlAss + "/profile/info",
        params: params,
    });
// Get Orders
export const getOrderInfo = (params) =>
    requestBase.request({
        method: "get",
        url: segments.urlAss + "/orders/count",
        params: params,
    });
// Get Info
export const districtList = (params) =>
    requestBase.request({
        method: "get",
        url: segments.urlAss + "/districts",
        params: params,
    });
// 图片上传
export const uploadImg = (paramters) => requestBase.post(segments.urlCommonFs + "/yhproduct/upload2", paramters);

// 导出订单
export const exportOrder = (params) =>
    requestBaseFile.request({
        method: "get",
        url: segments.urlAss + "/orders/export",
        params: params,
    });
// banner列表
export const bannerList = (params) =>
    requestBase.request({
        method: "get",
        url: segments.urlAss + "/banners",
        params: params,
    });
// banner 编辑
export const bannerEdit = (data) =>
    requestBase.request({
        method: "put",
        url: segments.urlAss + "/banners/" + data.id,
        data: data,
    });
// 图片上传
export const upload = (data) =>
    requestBase.request({
        method: "post",
        url: segments.urlAss + "/upload",
        data: data,
    });

// banner 新增
export const bannerAdd = (data) =>
    requestBase.request({
        method: "post",
        url: segments.urlAss + "/banners",
        data: data,
    });
// banner 删除
export const bannerDelete = (data) =>
    requestBase.request({
        method: "delete",
        url: segments.urlAss + "/banners/" + data.id,
    });
    // 所有门店
export const branchesList = () =>
    requestBase.request({
        method: "get",
        url: "/bms-api/branches/all",
     });
     // 查询工人
     export const searchWorkers = (params) =>
        requestBase.request({
            method: "get",
            url: segments.urlAss + "/workers",
            params: params,
        });
 // 用户列表
 export const searchUsers = (params) =>
    requestBase.request({
        method: "get",
        url: segments.urlAss + "/fs-users",
        params: params,
    });
 export const searchUsersCashback = (params) =>
    requestBase.request({
        method: "get",
        url: segments.urlAss + "/cashback",
        params: params,
    });
export const cashbackfsUsersEdit = (data) =>
    requestBase.request({
        method: "put",
        url: segments.urlAss + "/fs-users/" + data.id,
        data: data,
    });

 // 提现列表
 export const searchcashbackAllOrder = (params) =>
    requestBase.request({
        method: "get",
        url: segments.urlAss + "/cashback-all-order",
        params: params,
    });

export const backAllOrderEdit = (data) =>
    requestBase.request({
        method: "put",
        url: segments.urlAss + "/cashback-all-order/" + data.id,
        data: data,
    });

export const searchcashbackDescribe = (params) =>
    requestBase.request({
        method: "get",
        url: segments.urlAss + "/cashback-describe",
        params: params,
    });
export const cashbackDescribeEdit = (data) =>
    requestBase.request({
        method: "put",
        url: segments.urlAss + "/cashback-describe/" + data.id,
        data: data,
    });

export const cashbackDescribeAdd = (data) =>
    requestBase.request({
        method: "post",
        url: segments.urlAss + "/cashback-describe",
        data: data,
    });